import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/shared/PageHeader';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Badge } from '../components/ui/badge';
import { EmptyState } from '../components/shared/EmptyState';
import { ActionsMenu } from '../components/shared/ActionsMenu';
import { useAppContext } from '../lib/store';
import { Plus, Search, Edit, Eye, Building2 } from 'lucide-react';
export function CustomerListPage() {
  const navigate = useNavigate();
  const {
    customers,
    workOrders
  } = useAppContext();
  const [searchTerm, setSearchTerm] = useState('');
  const filteredCustomers = customers.filter(c => c.name.toLowerCase().includes(searchTerm.toLowerCase()) || c.prefix.toLowerCase().includes(searchTerm.toLowerCase()) || c.tax_number.includes(searchTerm));
  return <div className="space-y-6" data-id="element-293">
      <PageHeader title="Stranke" description="Upravljanje s strankami in njihovimi podatki." data-id="element-294">
        <Button onClick={() => navigate('/stranke/nova')} data-id="element-295">
          <Plus className="w-4 h-4 mr-2" data-id="element-296" />
          Nova stranka
        </Button>
      </PageHeader>

      <div className="flex items-center gap-4 mb-6" data-id="element-297">
        <div className="relative flex-1 max-w-md" data-id="element-298">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-299" />
          <Input placeholder="Iskanje po nazivu, predponi ali davčni št..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-9" data-id="element-300" />
        </div>
      </div>

      <div className="bg-white border rounded-lg" data-id="element-301">
        {filteredCustomers.length > 0 ? <Table data-id="element-302">
            <TableHeader data-id="element-303">
              <TableRow data-id="element-304">
                <TableHead data-id="element-305">Naziv</TableHead>
                <TableHead data-id="element-306">Predpona</TableHead>
                <TableHead className="text-center" data-id="element-307">Št. nalogov</TableHead>
                <TableHead className="w-[60px]" data-id="element-308"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-id="element-309">
              {filteredCustomers.map(customer => {
            const woCount = workOrders.filter(wo => wo.customer_id === customer.id).length;
            return <TableRow key={customer.id} data-id="element-310">
                    <TableCell className="font-medium" data-id="element-311">
                      {customer.name}
                    </TableCell>
                    <TableCell data-id="element-312">
                      <Badge variant="outline" className="font-mono" data-id="element-313">
                        {customer.prefix}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-center" data-id="element-314">{woCount}</TableCell>
                    <TableCell data-id="element-315">
                      <ActionsMenu items={[{
                  label: 'Prikaži',
                  icon: <Eye className="w-4 h-4" data-id="element-317" />,
                  onClick: () => navigate(`/stranke/${customer.id}`)
                }, {
                  label: 'Uredi',
                  icon: <Edit className="w-4 h-4" data-id="element-318" />,
                  onClick: () => navigate(`/stranke/${customer.id}/uredi`)
                }]} data-id="element-316" />
                    </TableCell>
                  </TableRow>;
          })}
            </TableBody>
          </Table> : <EmptyState icon={Building2} title="Ni najdenih strank" description={searchTerm ? 'Spremenite iskalni niz in poskusite znova.' : 'V sistemu še ni vnesenih strank.'} actionLabel={searchTerm ? undefined : 'Dodaj stranko'} onAction={searchTerm ? undefined : () => navigate('/stranke/nova')} data-id="element-319" />}
      </div>
    </div>;
}